import classNames from 'classnames';
import { bool, string } from 'prop-types';

import ButtonPlainPromised, {
  propTypes as ButtonPlainPromisedProps,
} from '~/components/ButtonPlainPromised';

import style from './BottomPopupButton.module.scss';

export const SIDES = {
  LEFT: 'leftButton',
  RIGHT: 'rightButton',
};
// todo: merge with atoms/styledButton
export default function BottomPopupButton({
  className,
  divider,
  dividerClassName,
  side,
  ...props
}) {
  return (
    <>
      {divider && (
        <div className={classNames(style.divider, dividerClassName)}></div>
      )}
      <ButtonPlainPromised
        className={classNames(style.button, style[side], className)}
        {...props}
      />
    </>
  );
}

BottomPopupButton.propTypes = {
  ...ButtonPlainPromisedProps,
  divider: bool,
  dividerClassName: string,
  className: string,
  side: string,
};
